import React from 'react';
import gdprCertificate from '@/finsight/ui/components/staticPages/StaticPageHeader/assets/gdprCert.webp';
import mifidCertificate from '@/finsight/ui/components/staticPages/StaticPageHeader/assets/mifidCert.webp';
import privacyShieldCertificate from '@/finsight/ui/components/staticPages/StaticPageHeader/assets/privacyShieldCert.webp';
import soc2Certificate from '@/finsight/ui/components/staticPages/StaticPageHeader/assets/soc2Cert.webp';
import hipaaCertificate from '@/finsight/ui/components/staticPages/StaticPageHeader/assets/hipaaCert.svg';

import CFR_URL from '@/creditflowresearch/Router/urlConstants';
import { staticPaths } from '@finsight/urls/static';
import BackgroundMap from '@/finsight/ui/components/staticPages/Company/BackgroundMap';
import Certificates from '@/finsight/ui/components/staticPages/Policies/Certificates';
import styles from '@/finsight/ui/components/staticPages/Policies/policies.module.scss';

const certificates = (
  <Certificates
    items={ [
      {
        id: 'gdpr-id',
        src: gdprCertificate.src,
        alt: 'GDPR Certificate',
      },
      {
        id: 'mifid-id',
        src: mifidCertificate.src,
        alt: 'MiFID II Certificate',
      },
      {
        id: 'privacy-shield-id',
        src: privacyShieldCertificate.src,
        alt: 'Data Privacy Framework Certificate',
        className: styles.privacyShieldCertificate,
      },
      {
        id: 'aicpa-id',
        src: soc2Certificate.src,
        alt: 'AICPA SOC 2 Certificate',
        className: styles.soc2Certificate,
      },
    ] }
  />
);

export const staticPages = {
  [staticPaths.getTermsOfUsePath()]: {
    title: 'Terms of Use',
    tagLine: 'By utilizing our services, you agree to the below.',
  },
  [staticPaths.getPrivacyPolicyPath()]: {
    title: 'Privacy Policy',
    tagLine: "It's our job to protect our client's data. Below is how we handle your personal information.",
  },
  [staticPaths.getSecurityPolicyPath()]: {
    title: 'Security Policy',
    tagLine: 'Information security is a top priority.',
    children: certificates,
  },
  [staticPaths.getCompliancePath()]: {
    title: 'Compliance Policy',
    tagLine: 'Finsight actively monitors global regulations to ensure compliance.',
    children: certificates,
  },
  [staticPaths.getHipaaCompliancePath()]: {
    title: 'HIPAA Compliance at Finsight',
    tagLine: 'Secure handling of Protected Health Information within DealVDR.',
    children: (
      <Certificates
        items={ [
          {
            id: 'hipaa-id',
            src: hipaaCertificate,
            alt: 'HIPAA Compliance Certificate',
            className: styles.hipaaCertificate,
          },
        ] }
      />
    ),
  },
  [staticPaths.getAboutPath()]: {
    title: 'About Us',
    tagLine: 'Unparalleled visibility and actionable insights.',
  },
  [staticPaths.getCareersPath()]: {
    title: 'Careers',
    tagLine: 'Wanted: Talented People!',
    headerBackgroundComponent: BackgroundMap,
  },
  [staticPaths.getSolutionsPath()]: {
    title: 'Our Solutions',
    tagLine: 'Better tools for better execution.',
  },
  [staticPaths.getContactPath()]: {
    title: 'Contact Us',
    tagLine: 'Our Fanatical 24x7 Sales & Support teams are standing by.',
    headerBackgroundComponent: BackgroundMap,
  },
  [CFR_URL.ISSUERS_LIST]: {
    title: 'List of Global Fixed Income Issuers',
    tagLine: 'A list of all fixed income issuers across all products and regions on CreditFlow',
  },
  [CFR_URL.SPONSORS_LIST]: {
    title: 'List of Global Fixed Income Parents',
    tagLine: 'A list of all fixed income parents across all products and regions on CreditFlow',
  },
  [CFR_URL.SUBSCRIPTIONS]: {
    title: 'Email Subscriptions',
    tagLine: 'Manage all of your CreditFlow email subscriptions in one place.',
  },
  [CFR_URL.PRICING]: {
    title: 'Market Data Pricing',
    tagLine: 'Our Fanatical 24x7 Sales & Support are standing by.',
  },
  [CFR_URL.OPEN_MARKET]: {
    title: 'OpenMarket Profile',
    tagLine: 'All live roadshows across the globe for Investors.',
  },
  [CFR_URL.EXCEL_ADD_IN_GUIDE_POLICY]: {
    title: 'Privacy Policy for CreditFlow for Excel',
    tagLine: '',
  },
};
